/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CoverageKindEnum = {
    Coverage: 'Coverage',
    ChildCoverage: 'ChildCoverage',
    SummaryCoverage: 'SummaryCoverage',
    PremiumFactor: 'PremiumFactor'
} as const;
export type CoverageKindEnum = typeof CoverageKindEnum[keyof typeof CoverageKindEnum];


export function instanceOfCoverageKindEnum(value: any): boolean {
    for (const key in CoverageKindEnum) {
        if (Object.prototype.hasOwnProperty.call(CoverageKindEnum, key)) {
            if (CoverageKindEnum[key as keyof typeof CoverageKindEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CoverageKindEnumFromJSON(json: any): CoverageKindEnum {
    return CoverageKindEnumFromJSONTyped(json, false);
}

export function CoverageKindEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoverageKindEnum {
    return json as CoverageKindEnum;
}

export function CoverageKindEnumToJSON(value?: CoverageKindEnum | null): any {
    return value as any;
}

export function CoverageKindEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): CoverageKindEnum {
    return value as CoverageKindEnum;
}

